<template>
  <div>
    <div class="page1"
         v-if="page == 1">
      <div class="gl_title_bar marginBottom10">
        <div class="gl_tb_left">
          <span class="normaltitle">机构入驻申请</span>
        </div>
      </div>
      <div class="xuzhi">
        <div class="xztitle">机构店铺入驻须知</div>
        <div class="xznr">“机构入驻”板块为展示优秀基层医疗卫生机构在家庭医生签约、人才培养、慢病管理、患者教育等方面的优秀案例，以及辅助全科医生培训、学习，提高临床技能的全方位平台，诚邀全国（省、市）百强社区卫生服务中心、全国满意乡镇卫生院、卫生行政部门（社管中心）、综合医院全科医学科等入驻。</div>
        <div class="xzbtn"
             @click="page = 2">入驻申请</div>
      </div>
      <div class="list">
        <div class="listtop">
          <img :src="avatarUrl"
               alt="" />
          <span>{{ mobile.substr(0, 8) }}***的机构店铺</span>
        </div>
        <div class="listbox">
          <table>
            <thead>
              <tr>
                <th>机构店铺名称</th>
                <th>审核状态</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in storeList"
                  :key="index">
                <td>{{ item.orgName }}</td>
                <td>
                  <span v-show="item.type == 1">待审核</span>
                  <span v-show="item.type == 2"
                        style="color:#FF0000">审核未通过<span v-show="item.remark">{{ item.remark }}</span></span>
                  <span style="color:#0B8586"
                        v-show="item.type == 3">审核已通过</span>
                </td>
                <td>
                  <span style="color:#0B8586;cursor:pointer"
                        @click="toupdata(item.id)"
                        v-show="item.type == 1 || item.type == 2">修改</span>
                  <span style="color:#0B8586;cursor:pointer"
                        @click="toStore(item.orgId, item.orgName)"
                        v-show="item.type == 3">我的店铺</span>
                </td>
              </tr>
              <tr v-show="storeList.length<1">
                <td colspan="3">暂无店铺信息</td>
              </tr>
            </tbody>
          </table>
        </div>
        <pagination :total="pageCount"
                    :limit="pageSize"
                    :page="pageIndex"
                    @page-change="pageChange"></pagination>
      </div>
    </div>
    <div class="page2"
         v-if="page == 2">
      <div class="gl_title_bar marginBottom10">
        <div class="gl_tb_left">
          <span class="normaltitle">申请入驻</span>
        </div>
      </div>
      <div class="form">
        <el-form :model="ruleForm"
                 :rules="rules"
                 ref="ruleForm"
                 label-width="93px"
                 style="position:relative;"
                 class="demo-ruleForm">
          <el-form-item label="机构名称："
                        prop="name"
                        style="margin-bottom:40px">
            <el-input v-model="ruleForm.name"
                      placeholder="请输入机构名称"
                      style="width: 633px;"></el-input>
          </el-form-item>
          <span style="position: absolute;top: 45px;left: 93px;font-size: 12px;color: #999999;">您所在机构如果为基层医疗机构请在机构名称前加省市！</span>
          <el-form-item label="机构类型："
                        prop="type">
            <el-select v-model="ruleForm.type"
                       placeholder="请选择机构类型"
                       style="width: 633px;">
              <el-option v-for="item in OrgTypeOptions"
                         :key="item.id"
                         :label="item.valueText"
                         :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="地域："
                        prop="region">
            <el-cascader v-model="ruleForm.region"
                         style="width: 633px;"
                         placeholder="请选择省市区县"
                         :options="arealist"
                         @expand-change="expandChange"></el-cascader>
          </el-form-item>
          <el-form-item label="封面图："
                        style="width:400px;margin-bottom:22px;"
                        prop="banar">

            <webupload fileaccept=".jpg,.jpeg,.png"
                       :Maxfileszie="3"
                       :uploadtype="2"
                       :orgid="orgid"
                       :onSuccess="handleSuccess3"
                       class="addt4box">
              <div class="addmp4box"
                   v-show="!bansrc">
                <img src="../../../assets/img/icon/import.png"
                     alt="">
                <span>上传图片</span>
              </div>
              <img :src="bansrc"
                   v-show="bansrc"
                   class="banimg"
                   alt="">
            </webupload>
            <span style="position: absolute;top: 45px;left: 0px;font-size: 12px;font-family: Microsoft YaHei;font-weight: 400;color: #999999;">支持扩展名：png、jpg、496*280像素</span>
          </el-form-item>
          <el-form-item label="授权书上传："
                        label-width="107px"
                        style="height:53px"
                        prop="certificate">
            <webupload fileaccept=".pdf"
                       :Maxfileszie="100"
                       :uploadtype="2"
                       :orgid="orgid"
                       :onSuccess="handleSuccess"
                       style="padding-bottom:-60px;float: left;">
              <div class="shouquanshu">
                <img src="../../../assets/img/icon/bianji2.png"
                     alt="">
                <span>{{ruleForm.pdfname}}</span>
              </div>
            </webupload>
            <div style="position:relative;top:0px;left:50px;font-size: 14px;color: #CC0000;display:flex;">
              <img src="../../../assets/img/shouquanshu.png"
                   alt=""
                   style="margin-right:10px;color: #333333;">
              <span>入驻机构店铺授权书模板</span>
            </div>
            <span style="position: absolute;top: 35px;left: 0px;font-size: 12px;font-family: Microsoft YaHei;font-weight: 400;color: #999999;">支持pdf格式的文件</span>
          </el-form-item>
          <el-form-item label="尺寸199*61像素"
                        label-width="130px"
                        style="position:absolute;top:110px;right:0px;"
                        prop="logoImg">
            <webupload fileaccept=".jpg,.jpeg,.png"
                       :Maxfileszie="3"
                       :uploadtype="2"
                       :orgid="orgid"
                       :onSuccess="handleSuccess2"
                       :before-upload="beforeAvatarUpload"
                       style="width:133px;height:40px;;background: #0b868613;position:absolute;top:-70px;left:-135px;">
              <img v-if="ruleForm.logoImg"
                   :src="ruleForm.logoImg"
                   style="width:133px;height:40px"
                   class="avatar" />
              <i v-else
                 style="color:#0B8586;font-size:30px;padding:5px 50px;"
                 class="el-icon-plus avatar-uploader-icon"></i>
            </webupload>
            <span style="position:absolute;top:-21px;left:-90px;width:100px;font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;">机构Logo</span>
          </el-form-item>
          <el-form-item class="xieyi">
            <el-checkbox v-model="isXieyi"
                         class="xy1"></el-checkbox>
            <span class="xy2">我已阅读和同意</span>
            <span class="xy3"
                  @click="isXieyiBox=true">《全科知家机构入驻协议书》</span>
            <el-dialog title="全科知家机构入驻协议书"
                       :visible.sync="isXieyiBox"
                       class="xieyibox"
                       width="760px">
              <div class="xynr">
                一、特别提示
                您只有无条件同意《全科知家内容上传协议》，才能在全科知家网的文章分区投稿。
                1.1 全科知家同意按照本协议的规定及其不时发布的操作规则提供基于互联网的相关服务(以下称"网络服务")，为获得网络服务，服务使用人(以下称"用户")同意本协议的全部条款并按照页面上的提示完成全部的注册程序。用户在进行注册程序过程中点击"同意"按钮即表示用户完全接受本声明项下的全部条款。这些条款可由全科知家域名所有者随时更新，本服务协议一旦发生变动，全科知家将会在相关的页面上提示修改内容。修改后的服务协议一旦在页面上公布即有效代替原来的服务协议。用户可随时造访查阅最新服务协议。用户在使用全科知家提供的各项服务之前，应仔细阅读本服务协议，如用户不同意本服务协议及/或随时对其的修改，用户可以主动取消全科知家提供的服务。
                1.2 全科知家作为信息分享、交流的服务平台，为用户提供原创信息的信息存储空间服务，用户应合法、有权的使用全科知家发表信息并单独对此承担法律责任。
                1.3 用户承诺不得以任何方式使用全科知家直接或间接从事违反中华人民共和国相关法律规定及社会公序良俗的行为，用户不得使用全科知家服务制作、复制、上载、发布、展示或以其它方式传播含有下列内容之一的信息：
                （1）反对宪法所确定的基本原则的；
                （2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
                （3）损害国家荣誉和利益的；
                （4）煽动民族仇恨、民族歧视，破坏民族团结的；
                （5）破坏国家宗教政策，宣扬邪教和封建迷信的；
                （6）散布谣言，扰乱社会秩序，破坏社会稳定的；
                （7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；
                （8）侮辱或者诽谤他人，侵害他人合法权益的；
                （10）含有法律、行政法规禁止的其他内容的信息。
                二、版权声明
                2.1全科知家作为信息分享、交流的服务平台，尊重和鼓励用户原创内容，打造基于创作的文化原创社区。同时，全科知家也尊重任何第三方的合法权益。用户在使用全科知家发表信息时，不得以任何方式侵害任何第三方的合法权益，包括但不限于著作权、商标权、专利权、姓名权、隐私权等。
                2.2 用户使用全科知家发表的全部原创内容（包括但不限于文章、图片、视频等），其知识产权归用户所有。
                2.3 全科知家不会对用户上传的作品内容作任何形式的编辑修改。
                2.4用户使用全科知家发表的信息，除非用户明确允许转载的，禁止任何第三方转载或者摘编（用户使用官方“生成图片”功能分享的除外）；若该用户允许第三方转载或摘编信息至全科知家之外的平台，应在转载内容的显著位置注明原作者姓名（或笔名、全科知家用户昵称），注明内容来源于全科知家且附有原始链接，并不对转载内容进行修改或演绎。
                2.5对于用户使用全科知家发表的信息，若有相关权利人提出关于侵害著作权等合法权益的投诉，全科知家有权根据法律规定的要求删除相关信息。
              </div>
              <div class="xybtn"
                   @click="toxybtn"
                   :style="xieyiTime==0?'background-color: #0b8586;':''">
                <span>确认</span>
                <span v-show="xieyiTime!=0">（{{xieyiTime}}s）</span>
              </div>
            </el-dialog>
          </el-form-item>
          <el-form-item>
            <div class="xzbtn"
                 style="margin-left:180px"
                 @click="submitForm">提交申请</div>
            <div class="xzbtn"
                 style="margin-left:10px;background: #9EA2A2;"
                 @click="page = 1">取消</div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '../../components/page/pagination.vue';
import { areaList } from '@vant/area-data';
import webupload from '../../../components/webupload/webupload.vue';
export default {
  name: 'userVip',
  components: {
    Pagination,
    webupload
  },
  data () {
    return {
      ishowmodel: false,
      AuthorId: '',
      mobile: '',
      avatarUrl: '',
      page: 1,
      arealist: [],
      storeList: [],
      ruleForm: {
        name: '',
        type: '',
        region: '',
        logoImg: '',
        pdfname: '',
        logoImgId: '',
        certificateId: '',
        banid: ''
      },
      rules: {
        name: [{ required: true, message: ' ', trigger: 'change' }],
        type: [{ required: true, message: '请选择机构类型', trigger: 'change' }],
        region: [{ required: true, message: '请选择省市区县', trigger: 'change' }],
        logoImg: [{ required: true, message: '' }],
        certificate: [{ required: true, message: '', trigger: 'blur' }],
        banar: [{ required: true, message: '', trigger: 'blur' }]
      },
      pageCount: 0,
      pageIndex: 1,
      pageSize: 5,
      OrgTypeOptions: [],
      bansrc: '',

      isXieyi: false,
      isXieyiBox: false,
      xieyiTime: 3
    };
  },
  watch: {
    isXieyiBox: function (e) {
      if (e == true && this.xieyiTime != 0) {
        var test1 = setInterval(() => {
          if (this.xieyiTime > 0) {
            this.xieyiTime = this.xieyiTime - 1
          } else {
            clearInterval(test1);
          }
        }, 1000);
      }
    },
    isXieyi: function (e) {
      if (e == true && this.xieyiTime != 0) {
        this.isXieyi = false
        this.isXieyiBox = true
      }
    }
  },
  created () {
    this.getarealist();
    if (localStorage.getItem('ResData')) {
      this.AuthorId = JSON.parse(localStorage.getItem('ResData')).id;
      this.mobile = JSON.parse(localStorage.getItem('ResData')).mobile;
      this.avatarUrl = JSON.parse(localStorage.getItem('ResData')).avatarUrl;
    }
    this.GetOrgTypeList()
    this.GetMyStoreList();
  },
  methods: {
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    handleSuccess (response, file) {
      this.ishowmodel = true;
      this.ruleForm.pdfname = file.name
      this.ruleForm.certificateId = response.resid
    },
    handleSuccess2 (response) {
      this.ishowmodel = true;
      this.ruleForm.logoImg = response.ossfileurl
      this.ruleForm.logoImgId = response.resid
    },
    handleSuccess3 (response) {
      this.ruleForm.banid = response.resid;
      this.bansrc = response.ossfileurl;
    },
    GetMyStoreList () {
      this.httphelper
        .post('/api/CGPEnterPriseApi/GetPrgRecordPageList', {
          userId: Number(this.AuthorId),
          page: this.pageIndex,
          limit: this.pageSize
        })
        .then(res => {
          if (res.data.data) {
            this.storeList = res.data.data;
            this.pageCount = res.data.totalcount
          }
        });
    },
    getarealist () {
      for (let a in areaList.province_list) {
        this.arealist.push({
          value: a,
          label: areaList.province_list[a],
          children: []
        });
      }
    },
    submitForm () {
      if (this.isXieyi == false) {
        return this.isXieyiBox = true
      }
      if (this.ruleForm.name == '') {
        this.$message.warning('机构名称不能为空');
        return;
      } else if (this.ruleForm.type == '') {
        this.$message.warning('请选择机构类型');
        return;
      } else if (this.ruleForm.region == '' || this.ruleForm.region.length != 3) {
        this.$message.warning('请选择省市区县');
        return;
      } else if (this.ruleForm.logoImg == '') {
        this.$message.warning('请上传机构Logo');
        return;
      } else if (this.ruleForm.certificate == '') {
        this.$message.warning('请上传授权书');
        return;
      } else if (this.ruleForm.banid == '') {
        this.$message.warning('请上传封面图');
        return;
      }
      this.httphelper
        .post('/api/CGPEnterPriseApi/OrgRegApply', {
          userId: Number(this.AuthorId),
          id: 0,
          orgName: this.ruleForm.name,
          type: Number(this.ruleForm.type),
          provinceCode: this.ruleForm.region[0] ? this.ruleForm.region[0] : '',
          cityCode: this.ruleForm.region[1] ? this.ruleForm.region[1] : '',
          districtCode: this.ruleForm.region[2] ? this.ruleForm.region[2] : '',
          logorid: Number(this.ruleForm.logoImgId),
          filerid: Number(this.ruleForm.certificateId),
          bannId: Number(this.ruleForm.banid)
        })
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success('申请入驻成功');
            this.GetMyStoreList();
            this.page = 1;
          } else if (res.data.code == 205) {
            this.$message.error('您申请的机构已有申请记录，请核对机构名称重新申请！');
          }
        });
    },
    // upLoad1(file) {
    //     this.ruleForm.certificate = 5161;
    //     this.$message.success('上传成功');
    //     //   const formData = new FormData();
    //     //   formData.append('file', file.file);
    //     //   formData.append('Authorid', this.AuthorId);
    //     //   formData.append('OfType', 1);
    //     //   this.httphelper.post('/api/OssFileApi/ImageUpload', formData).then(res => {
    //     //     if (res.data.code) {
    //     //       this.$message({
    //     //         message: '头像上传成功',
    //     //         type: 'success'
    //     //       });
    //     //       this.form.headUrl = res.data.data.src;
    //     //       this.reload();
    //     //     } else {
    //     //       this.$message('头像上传失败失败');
    //     //     }
    //     //   });
    // },
    upLoad2 () {
      this.ruleForm.logoImg = 5161;
      this.$message.success('上传成功');
    },
    // handleAvatarSuccess (res, file) {
    //   this.form.headUrl = URL.createObjectURL(file.raw);
    // },
    /**点击分页事件 */
    pageChange (page) {
      if (page == this.pageIndex) {
        return;
      }
      this.pageIndex = page;
      this.GetMyStoreList();
    },
    expandChange (val) {
      if (val.length == 1) {
        for (let i = 0; i < this.arealist.length; i++) {
          if (this.arealist[i].value == val[0]) {
            this.arealist[i].children = [];
          }
        }
        for (let b in areaList.city_list) {
          if (b.substr(0, 2) == val[0].substr(0, 2)) {
            for (let i = 0; i < this.arealist.length; i++) {
              if (this.arealist[i].value == val[0]) {
                this.arealist[i].children.push({
                  value: b,
                  label: areaList.city_list[b],
                  children: []
                });
              }
            }
          }
        }
      } else if (val.length == 2) {
        for (let i = 0; i < this.arealist.length; i++) {
          if (this.arealist[i].value == val[0]) {
            for (let a = 0; a < this.arealist[i].children.length; a++) {
              if (this.arealist[i].children[a].value == val[1]) {
                this.arealist[i].children[a].children = [];
              }
            }
          }
        }
        for (let b in areaList.county_list) {
          if (b.substr(0, 4) == val[1].substr(0, 4)) {
            for (let i = 0; i < this.arealist.length; i++) {
              if (this.arealist[i].value == val[0]) {
                for (let a = 0; a < this.arealist[i].children.length; a++) {
                  this.arealist[i].children[a].children.push({
                    value: b,
                    label: areaList.county_list[b]
                  });
                }
              }
            }
          }
        }
      }
    },
    toupdata (id) {
      this.$router.push({
        path: '/user/orgEnterUpdate',
        query: {
          id: id
        }
      });
    },
    toStore (id, name) {
      localStorage.setItem('storeId', id);
      localStorage.setItem('storeType', 2);
      localStorage.setItem('storeName', name);
      this.$router.push({
        name: 'usProject'
      });
    },
    GetOrgTypeList () {
      this.httphelper
        .get('/api/BasicsmesApi/GetCodeResultList', {
          type: 5
        })
        .then(res => {
          if (res.code == 200) this.OrgTypeOptions = res.data
        });

    },
    toxybtn () {
      if (this.xieyiTime == 0) {
        this.isXieyiBox = false
        this.isXieyi = true
      }
    }
  }
};
</script>

<style scoped>
.xuzhi {
    border-bottom: 1px solid #e2e2e2;
    padding-bottom: 36px;
}
.xuzhi .xztitle {
    height: 18px;
    line-height: 18px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #0b8586;
    border-left: 2px solid #0b8586;
    padding-left: 14px;
    margin-top: 38px;
    margin-bottom: 10px;
}
.xuzhi .xznr {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 34px;
    height: 160px;
    overflow-y: auto;
    padding-right: 50px;
    text-indent: 28px;
}
.xzbtn {
    margin-top: 12px;
    margin-left: 375px;
    width: 200px;
    height: 36px;
    background: #0b8586;
    border-radius: 18px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 36px;
    text-align: center;
    cursor: pointer;
    display: inline-block;
}
.listtop {
    height: 80px;
    margin-top: 20px;
    display: flex;
    align-items: center;
}
.listtop img {
    width: 40px;
    height: 40px;
    margin-right: 10px;
    border-radius: 50%;
}
.listtop span {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
}
.listbox {
    width: 100%;
}
.listbox table {
    width: 100%;
    border-collapse: collapse;
}
.listbox th {
    width: 33.3%;
    height: 44px;
    background-color: #0b8586;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    border-color: #e2e2e2;
    border: 1px solid #e2e2e2;
}
.listbox td {
    width: 33.3%;
    height: 58px;
    background-color: #0b8586;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    background: #fafafa;
    text-align: center;
    border: 1px solid #e2e2e2;
}
.form {
    padding-top: 30px;
}
.shouquanshu {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #0b8586;
    width: 333px;
    border-bottom: 1px solid #e5e5e5;
    height: 40px;
    display: flex;
    align-items: center;
}
.shouquanshu img {
    margin-right: 10px;
    margin-left: 10px;
}
.banimg {
    width: 96px;
    height: 54px;
}
.addt4box ::v-deep .el-upload--text {
    height: 54px;
}
.addt4box {
    height: 54px;
}
.addmp4box {
    width: 109px;
    height: 30px;
    border: 1px solid #e5e5e5;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 0 15px;
    box-sizing: border-box;
    position: relative;
    top: 6px;
}
.addmp4box span {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin-left: 10px;
}
.xieyi {
    font-size: 14px;
    color: #606266;
    font-family: Microsoft YaHei;
    font-weight: 400;
}
.xieyi .xy1 {
    margin-right: 8px;
}
.xieyi .xy1 ::v-deep .el-checkbox__inner {
    border-color: #0b8586;
}
.xieyi .xy1 ::v-deep.is-checked .el-checkbox__inner {
    background-color: #0b8586;
}
.xieyi .xy3 {
    color: #0b8586;
    cursor: pointer;
}
.xieyibox ::v-deep .el-dialog {
    height: 550px;
}
.xieyibox ::v-deep .el-dialog__header {
    text-align: center;
    padding-bottom: 0px;
    font-weight: 800;
}
.xieyibox .xynr {
    height: 355px;
    padding: 0 10px;
    overflow-y: scroll;
    scrollbar-color: transparent transparent;
    scrollbar-arrow-color: #f0f2f5; /* 设置滚动条上的箭头颜色  */
    scrollbar-base-color: #f0f2f5; /* 设置滚动条的底色 */
    scrollbar-track-color: #f0f2f5; /* 设置滚动条块的背景色 */
    scrollbar-shadow-color: #f0f2f5; /* 设置箭头和滚动条右侧和底边的颜色 */
}
.xieyibox .xynr::-webkit-scrollbar {
    /* 滚动条宽 */
    width: 6px;
    height: 4px;
}
.xieyibox .xynr::-webkit-scrollbar-thumb {
    /* 滚动条 拖动条 */
    background: #0b86864d;
    opacity: 0.3;
    border-radius: 6px;
}
.xieyibox .xynr::-webkit-scrollbar-track {
    /* 滚动条背景槽 */
    background-color: #fff;
    border-radius: 6px;
}
.xieyibox .xybtn {
    width: 160px;
    height: 40px;
    /* background-color: #0b8586; */
    background-color: #0b868638;
    border-radius: 20px;
    margin: 30px auto 0;
    line-height: 40px;
    text-align: center;
    font-size: 16px;
    color: #fff;
    cursor: pointer;
}
</style>
